import Vue from 'vue'
//import './plugins/axios'
import App from './App.vue'
import router from './router/index.js'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import axios from './http.js';
import util from './mixins/util.js';
import Vue2Editor from "vue2-editor";
import Qs from 'qs'
axios.defaults.withCredentials = false;
axios.defaults.mode = "cors";
// = "http://localhost:8088";
axios.defaults.baseURL = Config.domain;//"http://localhost:8088";
//axios.defaults.baseURL = "http://115.29.205.25:8088";
Vue.prototype.$axios = axios;
Vue.prototype.$dataGridMsg = "正在加载...";
Vue.prototype.$util = util;
Vue.prototype.qs = Qs

import mixins from "@/mixins/publicFun";
Vue.mixin(mixins)

Vue.use(Vue2Editor);

import Print from 'vue-print-nb'
Vue.use(Print)

import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu);

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

import './mixins/mathjax.js'
import  'mathjax/es5/tex-mml-chtml.js'


Vue.use(ElementUI);
Vue.config.productionTip = false;
//引入vueRouter实例并且挂载到vue实例上
new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
